export const commonStrings = () => {
   enum CurrencySymbols {
      PTBR = "R$",
   }

   return {
      PTBR: {
         core: {
            currency_symbol: CurrencySymbols.PTBR,
            navbarTop: {
               about: "sobre nós",
               contact: "fale conosco",
               faq: "dúvidas",
            },
            navbarHeader: {
               links: {
                  home: "início",
                  moreParts: "mais peças",
                  beAdvertiser: "quero anunciary",
                  beBuyer: "quero comprar",
               },
               search: {
                  placeholder: "Digite aqui o nome da peça que procura",
                  button: "Pesquisar",
               },
               login: "Login",
               logout: "Logout",
            },
            navbarFooter: {
               title: "NÃO ENCONTROU O QUE PROCURA?",
               description:
                  "Cadastre-se para ser notificado quando houver uma peça disponível",
               about: {
                  title: "Sobre Nós",
                  description: `O site ${process.env.REACT_APP_NAME} não realiza e também não intermedia a venda de peças, nós apenas permitimos que os proprietários anunciem sob sua responsabilidade.`,
               },
            },
            noData: {
               description: "Nenhuma peça por aqui",
               invitation: "Comece a divulgar suas peças agora mesmo, totalmente de graça!",
            },
         },
         autoParts: {
            national: "PEÇAS DE NACIONAIS",
            imported: "PEÇAS DE IMPORTADOS",
            priceFrom: `A partir de ${CurrencySymbols.PTBR} `,
         },
         mostViewed: {
            title: "peças mais vistas",
         },
         mostRecent: {
            title: "peças +recentes",
         },
         filter: {
            title: "Filtrar",
            groups: {
               manufacturer: "fabricante",
               year: "ano",
            },
         },
         authPage: {
            policy: (termsUrl, privacyUrl) =>
               `Ao continuar, você concorda e aceita nossos {${termsUrl},Termos de Uso} e {${privacyUrl},Políticas de Privacidade}.`,
            signUp: {
               steps: {
                  0: "Olá",
                  1: "Contato",
                  2: "Validação",
               },
               step1: {
                  title:
                     "Para sua segurança nós utilizamos sua conta na Google para te identificar. Por favor entre com seu login",
               },
               step2: {
                  label: "Informe seu número de telefone celular",
                  placeholder: "(99) 9-8765-4321",
               },
               step3: {
                  label:
                     "Enviamos um código de verificação para seu celular, confirme-o digitando abaixo:",
               },
               button_continue: "Continuar",
               button_back: "Voltar",
               button_done: "Validar",
               phoneValidation: {
                  phoneInvalidTitle: "Código de Verificação Incorreto",
                  phoneInvalidDescription:
                     "Este código não corresponde ao código enviado. Tente novamente.",
               },
            },
         },
         subscription: {
            description: `Assinando qualquer um dos planos, você poderá anunciar mais peças e ter maior visibilidade no site ${process.env.REACT_APP_NAME}.<br />Ao fazer um anúncio, nós nos encarregaremos de notificá-lo assim que um usuário demonstrar interesse na peça anunciada.`,
         },
         dashboard: {
            empty_content: "Uops, nada por aqui!",
            auto_part: {
               create: {
                  title: "Produtos",
                  subtitle_one: "Sobre o Produto",
                  subtitle_two: "Compatibilidade",
                  subtitle_three: "Imagens",
                  form: {
                     part_name: {
                        label: "Nome da Peça",
                        placeholder: "Digite o nome da peça",
                     },
                     manufacturer: {
                        placeholder: "Fabricante da Peça",
                     },
                     price: {
                        placeholder: "Valor da Peça",
                     },
                     brand: {
                        placeholder: "Marca",
                     },
                     model: {
                        placeholder: "Modelo",
                        national: "Este é um modelo de carro nacional",
                     },
                     quantity: {
                        placeholder: "Estoque de peças idênticas",
                     },
                     description: {
                        placeholder: "Digite informações sobre a peça",
                     },
                     isNew: "NOvo",
                     image: {
                        label: "Escolha imagens (JPG, PNG, JFIF, WEBP)",
                     },
                     buttonCancel: "Cancelar",
                     buttonSubmit: "Gravar",
                  },
                  updated: "Produto atualizado com sucesso!",
                  created: "Produto cadastrado com sucesso!",
               },
               list: {
                  title: "Produtos",
                  deleted: "Produto removido com sucesso!",
               },
            },
         },
      },
   };
};
